import { type OrderGetOrderDetailsOrderItemWorkflowReadDtoWorkflowTypeEnum } from "@/config/apiClient";

type WorkflowIsWithSubWorkflow = {
  [key in OrderGetOrderDetailsOrderItemWorkflowReadDtoWorkflowTypeEnum]: boolean;
};

// isWorkflowWithQuote
const workflowIsWithQuoteMapper: WorkflowIsWithSubWorkflow = {
  QUOTE_PRE_MEDIA_PROOF_DELIVERY_AND_RETRO_PLANNING: true,
  QUOTE_PRE_MEDIA_PROOF_PURCHASE_ORDER_DELIVERY_AND_RETRO_PLAN: true,
  QUOTE_PROOF_DELIVERY_AND_RETRO_PLANNING: true,
  QUOTE_PROOF_DELIVERY_LABEL_DELIVERY_AND_RETRO_PLANNING: true,
  QUOTE_PROOF_DELIVERY_LABEL_PO_DELIVERY_AND_RETRO_PLANNING: true,
  QUOTE_PROOF_PURCHASE_ORDER_DELIVERY_AND_RETRO_PLANNING: true,
  PRE_MEDIA_PROOF_DELIVERY_AND_RETRO_PLANNING: false,
  PRE_MEDIA_PROOF_PURCHASE_ORDER_DELIVERY_AND_RETRO_PLANNING: false,
  PROOF_DELIVERY_AND_RETRO_PLANNING: false,
  PROOF_PURCHASE_ORDER_DELIVERY_AND_RETRO_PLANNING: false,
};

export const isWorkflowWithQuote = (
  workflowType: OrderGetOrderDetailsOrderItemWorkflowReadDtoWorkflowTypeEnum
): boolean => {
  return workflowIsWithQuoteMapper[workflowType];
};
